import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import QRCode from 'qrcode';
import { cn } from '../../lib/cn.js';
import { Skeleton } from '../skeleton/Skeleton.js';
export function QrCode({ value, size = 176, label, className }) {
    const [state, setState] = React.useState({ status: 'loading' });
    React.useEffect(() => {
        let cancelled = false;
        setState({ status: 'loading' });
        QRCode.toString(value, {
            type: 'svg',
            errorCorrectionLevel: 'M',
            // A 1-module quiet zone is the minimum ISO/IEC 18004 allows, not the zero this
            // library defaults callers into thinking is fine to skip — dropping the quiet
            // zone entirely is a common real-world reason a code that "looks right" on screen
            // fails to scan once printed edge-to-edge on a receipt.
            margin: 2,
            color: { dark: '#000000', light: '#FFFFFF' },
        })
            .then((svg) => {
            if (!cancelled)
                setState({ status: 'ready', svg });
        })
            .catch(() => {
            if (!cancelled)
                setState({ status: 'error' });
        });
        return () => {
            cancelled = true;
        };
    }, [value]);
    const boxStyle = { width: size, height: size };
    if (state.status === 'loading') {
        return (_jsx("div", { role: "status", "aria-label": label, className: className, style: boxStyle, children: _jsx(Skeleton, { shape: "block", className: "h-full w-full" }) }));
    }
    if (state.status === 'error') {
        // Never a bare failure: the raw value is still shown, selectable/copyable text, so
        // the citizen-facing workflow this receipt exists for still has a fallback — typing
        // the tracking code in by hand on the public lookup page — even though the
        // convenience of a camera scan is unavailable.
        return (_jsx("div", { role: "img", "aria-label": label, className: cn('flex items-center justify-center rounded-md border border-status-critical-solid bg-white p-2 text-center text-xs break-all text-black', className), style: boxStyle, children: value }));
    }
    return (_jsx("div", { role: "img", "aria-label": label, className: cn('inline-block rounded-md bg-white p-1 print:p-0', className), style: boxStyle, 
        // The markup is this component's own `qrcode` output for a string it was handed as
        // a prop, never third-party or user-authored HTML — there is nothing here for
        // `dangerouslySetInnerHTML` to be dangerous about.
        dangerouslySetInnerHTML: { __html: state.svg } }));
}
//# sourceMappingURL=QrCode.js.map